<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>To my father, a man full of wisdom; and to the most gorgeous and exceptionally smart women in my life and their strong belief in me. My wife, Alexina, and my parents, Patricia and Boston (senior) – this is for you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?18ee2fcd